import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

import { IconContainer, SidebarContainer } from './sidebar.styles';
import useUser from 'hooks/useUser';
import { Link } from 'react-router-dom';

export const Sidebar = () => {
  const { currentUser } = useUser();

  return (
    <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-dark">
      <div className="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
        <Link
          to="/dashboard"
          className="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        >
          <span className="fs-5 d-none d-sm-inline text-white">
            EnergyPass Admin
          </span>
        </Link>
        <ul
          className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
          id="menu"
        >
          <li className="nav-item">
            <Link to="/admin/dashboard" className="nav-link align-middle px-0">
              <i className="fs-4 bi-house"></i>{' '}
              <span className="ms-1 d-none d-sm-inline">Dashboard</span>
            </Link>
          </li>
          <li>
            <Link
              to="/admin/clientes"
              data-bs-toggle="collapse"
              className="nav-link px-0 align-middle"
            >
              <i className="fs-4 bi-speedometer2"></i>{' '}
              <span className="ms-1 d-none d-sm-inline">Clientes</span>{' '}
            </Link>
          </li>
          <li>
            <Link
              to="/admin/faturamento"
              className="nav-link px-0 align-middle"
            >
              <i className="fs-4 bi-receipt"></i>{' '}
              <span className="ms-1 d-none d-sm-inline">Faturamento</span>
            </Link>
          </li>
          <li>
            <Link to="/admin/uso-contas" className="nav-link px-0 align-middle">
              <i className="fs-4 bi-activity"></i>{' '}
              <span className="ms-1 d-none d-sm-inline">Uso das contas</span>
            </Link>
          </li>
          <li>
            <Link to="/admin/servicos" className="nav-link px-0 align-middle">
              <i className="fs-4 bi-tools"></i>{' '}
              <span className="ms-1 d-none d-sm-inline">
                Serviços & Parceiros
              </span>
            </Link>
          </li>
          <li>
            <Link
              to="/admin/marketplace"
              className="nav-link px-0 align-middle"
            >
              <i className="fs-4 bi-shop"></i>{' '}
              <span className="ms-1 d-none d-sm-inline">Marketplace</span>
            </Link>
          </li>
        </ul>
        <hr />
        <Dropdown className="dropdown pb-4 bg-transparent">
          <Dropdown.Toggle className="d-flex align-items-center text-white text-decoration-none dropdown-toggle bg-transparent">
            <img
              src="https://github.com/mdo.png"
              alt="hugenerd"
              width="30"
              height="30"
              className="rounded-circle"
            />
            <span className="d-none d-sm-inline mx-1">
              {currentUser?.name || 'Admin'}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu dropdown-menu-dark text-small shadow">
            <Dropdown.Item>New project</Dropdown.Item>
            <Dropdown.Item>Sign out</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};
